import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import Single from "../views/Single.vue";

Vue.use(VueRouter);

const routes = [
    {
        path: "/",
        name: "Home",
        component: Home,
    },
    {
        path: "/view/:msg_id",
        name: "Single",
        component: Single,
    },
];

const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes,
});

export default router;
